import { NonNullableFormBuilder } from '@angular/forms';
import { Interval } from 'date-fns';

export interface Absence {
  attendants: AbsenceObject;
  staff: AbsenceObject;
}

export interface AbsenceObject {
  filledOut: boolean | Date[];
  absences: Record<string, AbsenceInterval[]>;
}

export interface AbsenceInterval extends Interval {
  reason?: string;
}

export const getDefaultAbsenceObject = (): Absence => ({
  attendants: {
    filledOut: true,
    absences: {},
  },
  staff: {
    filledOut: true,
    absences: {},
  },
});

export const createAbsenceFormGroup = (fb: NonNullableFormBuilder) => {
  return fb.group({
    attendants: fb.group({
      filledOut: fb.control(true),
      absences: fb.control({}),
    }),
    staff: fb.group({
      filledOut: fb.control(true),
      absences: fb.control({}),
    }),
  });
};
